import React from 'react'
import { Typography, Form, Button, Divider, Switch, Space, Row, } from 'antd';
import { useApp } from '../../../context/app-context';
import { CheckOutlined, } from '@ant-design/icons';

const { Title } = Typography;

export const AccountSettings = ({form}) => {

    const { state: {user}} = useApp();
    const {settings} = user;
    return(
        <>
            <div className='account__settings'>
                <Divider/>
                <Title level={5}>Station Settings</Title>
                {/* <Form name="account-settings-form" layout="vertical">   */}
                        <Space direction='vertical' size="middle">
                            <p>Select which panels are expanded by default:</p>
                            <Form.Item name="siteExpandable"  valuePropName="checked">
                                <Space>
                                    <Switch defaultChecked={settings?.siteExpandable} onChange={(value) => form.setFieldsValue({siteExpandable: value}) } checkedChildren={<CheckOutlined />}/>
                                    <p>Site Information</p>
                                </Space>
                            </Form.Item>

                            {/* <Form.Item name="devicesExpandable" valuePropName="checked">
                                <Space>
                                    <Switch defaultChecked={settings.devicesExpandable} onChange={(value) => form.setFieldsValue({devicesExpandable: value}) } checkedChildren={<CheckOutlined />} />
                                    <p>List of devices</p>
                                </Space>
                            </Form.Item> */}
                        </Space>
                {/* </Form> */}
            </div>
        </>
    );
} 